import React  from 'react'  ;
import App from './App'   ;
import {HashRouter,Route,Switch } from "react-router-dom";
import AllweatherFund  from "./pages/all-weather-hkchn/cn/all-weather-hkchn";
import Fund968195  from "./pages/detail/cn/968195";
import GaoxiFunds from "./pages/gaoxi-hkchn/cn/gaoxi-hkchn";
import HkeqFund from  "./pages/hkeq-hkchn/cn/hkeq-hkchn"
import GeqFund from "./pages/geq-hkchn/cn/geq-hkchn";
import  AsianBondFunds  from "./pages/asian-bond-hkchn/cn/asian-bond-hkchn"
import  AsianBondFunds3  from "./pages/asian-bond-hkchn/cn/asian-bond-hkchn-c3"
import  AsianBondFunds4  from "./pages/asian-bond-hkchn/cn/asian-bond-hkchn-c4"

export  default  class  IRouter  extends  React.Component{
    render() {
        return (
            <HashRouter >
                <App>
                    <Route path="/all-weather-hkchn" component={AllweatherFund}/>
                    <Route path="/968195" component={Fund968195}/>
                    <Route path="/gaoxi-hkchn" component={GaoxiFunds}/>
                    <Route path="/hkeq-hkchn" component={HkeqFund}/>
                    <Route path="/geq-hkchn" component={GeqFund}/>
                    <Route path="/asian-bond-hkchn" component={AsianBondFunds}/>
                    <Route path="/asian-bond-hkchn-c3" component={AsianBondFunds3}/>
                    <Route path="/asian-bond-hkchn-c4" component={AsianBondFunds4}/>
                </App>
            </HashRouter>
        );
    }
}
